import firebase from "firebase/app";
import "firebase/auth";
import "firebase/functions";
import "firebase/firestore";

const dev = {
    apiKey: "AIzaSyAEnWf6Yels6atydyts-PnfxKCA9zxhA-0",
    authDomain: "gixo-basic-stamprally.firebaseapp.com",
    databaseURL: "https://gixo-basic-stamprally.firebaseio.com",
    projectId: "gixo-basic-stamprally",
    storageBucket: "gixo-basic-stamprally.appspot.com",
    messagingSenderId: "1093219093798",
    appId: "1:1093219093798:web:582f4b7ae087deb02305e7",
    measurementId: "G-FN2TRSBJ96",
};

const prod = {
    apiKey: "AIzaSyALG8CUBv7xz_bTPPOmXSYmnWS4WxHmTBQ",
    authDomain: "stamp-rally.web.app",
    databaseURL: "https://gixo-basic-stamprally.firebaseio.com",
    projectId: "gixo-basic-stamprally",
    storageBucket: "gixo-basic-stamprally.appspot.com",
    messagingSenderId: "1093219093798",
    appId: "1:1093219093798:web:582f4b7ae087deb02305e7",
    measurementId: "G-FN2TRSBJ96"
};

firebase.initializeApp(process.env.NODE_ENV === "production" ? prod : dev);

export default firebase.app();
export const firestore = firebase.firestore();
export const FieldValue = firebase.firestore.FieldValue;
export const Timestamp = firebase.firestore.Timestamp;
